module.exports = __webpack_public_path__ + "static/media/Noreport.4937ee87.png";